// extracted by mini-css-extract-plugin
export default {"connect-page":"styles_connect-page__m4reR","connect-page-container":"styles_connect-page-container__8oYpi","paired-page-container":"styles_paired-page-container__Ii7sd"};